import ProjectedIncomeDetails from './feature/ProjectedIncomeDetails'

export const IncomeContainer: React.FC = () => {
  return <ProjectedIncomeDetails />
}
